import { Api } from '@/infrastructure';
import { Profile } from '@/types';
import React, { useEffect, useState } from 'react';
import {
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { RecreationFormValues } from './recreationNewForm';

type Props = {
  getValues: UseFormGetValues<RecreationFormValues>;
  register: UseFormRegister<RecreationFormValues>;
  setValue: UseFormSetValue<RecreationFormValues>;
};

export const ThirdStep: React.FC<Props> = (props) => {
  const { getValues, register, setValue } = props;
  // TODO(okubo): Profileの型も追加しておく
  const [profiles, setProfiles] = useState<Array<Profile>>([]);
  useEffect(() => {
    (async () => {
      try {
        const profilesData = await Api.get<Array<Profile>>(
          `profiles`,
          'partner'
        );
        const [firstProfile] = profilesData.data;
        // プロフィールが1件以上あることが前提の画面。空だと選択肢を出せず先に進めないため、
        // 黙って諦めずに例外として扱う
        if (firstProfile === undefined) {
          throw new Error('プロフィールが取得できませんでした');
        }
        setProfiles(profilesData.data);

        // 先頭を初期選択として見せている（defaultChecked）が、それだけでは react-hook-form に
        // 値が入らず送信時に「Profileが必要です」で弾かれるため、明示的に値を入れる
        if (getValues('profileId') === undefined) {
          setValue('profileId', firstProfile.id);
        }
      } catch (e) {
        console.warn('error is', e);
      }
    })();
  }, [getValues, setValue]);

  return (
    <div>
      <div className='d-flex'>
        <h5 className='text-black font-weight-bold'>プロフィールを選択</h5>
      </div>
      <hr className='my-2' />

      <div className='mt-4'>
        <h5 className='text-black font-weight-bold'>
          レクに表示するプロフィールを選択
        </h5>
      </div>
      {profiles.map((profile: Profile, i) => (
        <div key={i}>
          <input
            type='radio'
            id={`profileId${i}`}
            value={profile.id}
            {...register('profileId')}
            defaultChecked={i === 0 || profile.id === getValues('profileId')}
          />
          <label htmlFor={`profileId${i}`}>{profile.name}</label>
        </div>
      ))}
    </div>
  );
};
